import { render, staticRenderFns } from "./ChartOfAccountList.vue?vue&type=template&id=6b1ffcc2"
import script from "./ChartOfAccountList.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports